import axios from 'axios'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
  withCredentials: false,
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('specze_token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // Only treat a 401 as an expired session if we actually sent a token.
    // Public pages share this instance — a password-protected /share/:token
    // answers 401 by design, and bouncing an anonymous visitor to /login
    // (clearing storage on the way) is wrong.
    if (err.response?.status === 401 && localStorage.getItem('specze_token')) {
      localStorage.removeItem('specze_token')
      localStorage.removeItem('specze_user')
      window.location.href = '/login'
    }
    return Promise.reject(err)
  }
)

export default api
